import React from 'react';
import { FlexRow, Grid, Header3Text } from 'ui-toolkit';
import { Field, FieldArray, FieldProps } from 'formik';
import { BlockRedirection } from '../../../../cdBuilder/BlockRedirection';
import { CreateEditCheckDepositRow } from './CreateEditCheckDepositRow';
import { ICheckDepositData } from '../../../../../types/order/escrow/ICheckDeposit';
import { deleteCheckDepositAction } from '../../../../../store/order/escrow/deposits/checkDeposits/deleteCheckDepositSlice';
import { useAppDispatch } from 'store/store';
import { ePermissions } from '../../../../../types/administration/userAdministration/ePermissions';
import { HasPermissionButton } from '../../shared/HasPermissionButton';
import { useHasPermissions } from '../../../../accessControl/hooks/useHasPermissions';

export interface ICreateEditCheckDepositsContainerProps {
  dirty: boolean;
  onTransactionUpdate: () => void;
}

export const CreateEditCheckDepositsContainer: React.FC<ICreateEditCheckDepositsContainerProps> = ({
  dirty,
  onTransactionUpdate,
}) => {
  const dispatch = useAppDispatch();
  const hasEditPermission = useHasPermissions([ePermissions.EscrowExpectedIncomingChecksEdit]);

  const onRemoveCheckDeposit = async (checkToRemove: ICheckDepositData) => {
    if (checkToRemove.createdAt) {
      dispatch(deleteCheckDepositAction(checkToRemove.id));
      onTransactionUpdate();
    }
  };

  return (
    <>
      <BlockRedirection showSaveSpinner={false} showSaveSuccess={false} isDirty={dirty} />
      <FieldArray name={'checkDeposits'}>
        {({ push, remove }) => (
          <>
            <Grid>
              <FlexRow>
                <Header3Text>Check Deposits</Header3Text>
                <HasPermissionButton
                  hasEditPermission={hasEditPermission}
                  push={push}
                  successMessage={'Add Check'}
                  transferType={'check deposits'}
                  defaultObject={{ version: 'v1' }}
                />
              </FlexRow>
              <Field name={'checkDeposits'}>
                {({ field }: FieldProps<ICheckDepositData[]>) => (
                  <>
                    {field.value.map((check, index) => (
                      <CreateEditCheckDepositRow
                        key={index}
                        index={index}
                        onDelete={async (index) => {
                          remove(index);
                          await onRemoveCheckDeposit(check);
                        }}
                        fieldName={'checkDeposits'}
                      />
                    ))}
                  </>
                )}
              </Field>
            </Grid>
          </>
        )}
      </FieldArray>
    </>
  );
};
